import React, { Component, useState } from 'react'
import { navigate, Link } from 'gatsby'
import Disqus from 'disqus-react'
import Card from '../Card'
import moment from 'moment'
import PostTags from '../PostTags'
import PostCover from '../PostCover'
import config from '../../../data/SiteConfig'
import './PostPreview.scss'

class PostPreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: true,
      nutgrafIsShown: false,
    }
    this.handleResize = this.handleResize.bind(this)
    this.setIsShown = this.setIsShown.bind(this)
  }
  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  setIsShown(isShown) {
    this.setState({ nutgrafIsShown: isShown })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false })
    } else {
      this.setState({ mobile: true })
    }
  }

  openInNewTab(url) {
    const win = window.open(url, '_blank')
    if (win != null) {
      win.focus()
    }
  }

  handleClick(e, mobile, path) {
    if (!mobile) {
      if (e.ctrlKey || e.metaKey) {
        this.openInNewTab(path)
      } else {
        navigate(path)
      }
    }
  }

  formatExcerpt(s) {
    return s.substr(0, 150) + (s.length > 150 ? '...' : '')
  }

  render() {
    const { postInfo, cardClasses } = this.props
    const { mobile } = this.state

    const disqusShortname = config.disqusShortname
    const disqusConfig = {
      url: 'http://activelamp.com' + postInfo.path,
      title: postInfo.title,
    }

    let postNutgraf = ''
    if (postInfo.excerpt !== '' && postInfo.excerpt != null)
      postNutgraf = this.formatExcerpt(postInfo.excerpt)
    else if (postInfo.html !== '' && postInfo.html != null)
      postNutgraf = this.formatExcerpt(
        postInfo.html.replace(/(<([^>]+)>)/gi, '')
      )

    /* eslint no-undef: "off" */
    const coverHeight = mobile ? 444 : 475
    const styleSettings = mobile ? {} : { cursor: 'pointer' }
    const cardWidth = cardClasses ? cardClasses : 'width-6/12 post-preview'
    const className = `media-overlay ${
      !this.state.nutgrafIsShown ? '' : 'media-overlay--hidden'
    }`
    return (
      <Card width={cardWidth}>
        <div
          style={styleSettings}
          onClick={ev => {
            ev.preventDefault()
            this.handleClick(ev, mobile, postInfo.path)
          }}
        >
          <div
            className="media"
            style={{ height: coverHeight, paddingBottom: '0px' }}
            onMouseEnter={() => this.setIsShown(true)}
            onMouseLeave={() => this.setIsShown(false)}
          >
            <PostCover postNode={postInfo} coverHeight={coverHeight} />
            <div className={className}>
              {postInfo.layout === 'video' ? (
                <div className="post-layout">
                  <Link to={`/blog/${postInfo.category}`}>
                    <i title="Video" className="fa fa-play-circle"></i>
                    <span className="post-layout--type">
                      {' '}
                      Video - {postInfo.category}
                    </span>
                  </Link>
                </div>
              ) : (
                <div className="post-layout">
                  <Link to={`/blog/${postInfo.category}`}>
                    <i title="blog" className="fa fa-file-text-o"></i>
                    <span className="post-layout--type">
                      {' '}
                      Blog - {postInfo.category}
                    </span>
                  </Link>
                </div>
              )}
              <h4>
                <a
                  href={postInfo.path}
                  dangerouslySetInnerHTML={{ __html: postInfo.title }}
                ></a>
              </h4>
              <div className="post-info">
                <p>
                  <i title="Published on" className="fa fa-calendar"></i>{' '}
                  <span className="post-date">
                    {' '}
                    {moment(postInfo.date).format(config.dateFormat)}
                  </span>
                  <span className="author">
                    {' '}
                    by <strong>{postInfo.author}</strong>
                  </span>
                  {/* <span className="read-time">
                    {' '}
                    {`${postInfo.timeToRead} min read`}
                  </span> */}
                </p>
              </div>

              <div className="post-description">
                <p>{postInfo.excerpt}</p>
              </div>

              <div className="post-nutgraph">
                <p>{postNutgraf}</p>
              </div>
              <div className="post-tags">
                <i title="tags" className="fa fa-tag">
                  {' '}
                  Tagged
                </i>
                <PostTags tags={postInfo.tags} />
              </div>
              {postInfo.layout === 'video' ? (
                <div className="video-length">
                  <i title="Timer Length" className="fa fa-clock-o"></i>{' '}
                  <span>{postInfo.length}</span>
                </div>
              ) : (
                <div className="comment-count">
                  <i title="Speech Bubble" className="fa fa-comment">
                    {' '}
                    <Disqus.CommentCount
                      shortname={disqusShortname}
                      config={disqusConfig}
                    ></Disqus.CommentCount>{' '}
                    <span>Comments</span>{' '}
                  </i>
                </div>
              )}
            </div>
            {this.state.nutgrafIsShown && postNutgraf && (
              <div className="nutgraf-overlay">
                <p>{postNutgraf}</p>
                <Link className="read-more" to={postInfo.path}>
                  Read More
                </Link>
              </div>
            )}
          </div>
        </div>
      </Card>
    )
  }
}

export default PostPreview
